/**
 * react-hook-form helpers for contact email fields.
 * Core rule lives in `@attik/types` (`isSingleEmailAddress`).
 */
import {
  EMAIL_ADDRESS_DELIMITER,
  EMAIL_MAX_LENGTH,
  isSingleEmailAddress,
} from '@attik/types/contact.types';

export { isSingleEmailAddress } from '@attik/types/contact.types';

/** react-hook-form validate for a single optional/required email field. */
export function validateSingleEmailAddress(
  value: string | undefined | null,
  opts: { required?: boolean } = {}
): true | string {
  const trimmed = (value ?? '').trim();
  if (!trimmed) {
    return opts.required ? 'Email is required' : true;
  }
  if (EMAIL_ADDRESS_DELIMITER.test(trimmed)) {
    return 'Enter one email only — use CC for additional addresses';
  }
  if (trimmed.length > EMAIL_MAX_LENGTH) {
    return 'Email must be 255 characters or fewer';
  }
  if (!isSingleEmailAddress(trimmed.toLowerCase())) {
    return 'Please enter a valid email address';
  }
  return true;
}

/** react-hook-form validate for a comma-joined CC list (form stores string[]). */
export function validateCcEmails(
  emails: string[] | undefined | null
): true | string {
  if (!emails || emails.length === 0) return true;
  for (const email of emails) {
    const trimmed = (email ?? '').trim();
    if (!trimmed) {
      return 'CC emails cannot be empty';
    }
    if (EMAIL_ADDRESS_DELIMITER.test(trimmed)) {
      return 'Each CC email must be a single address (comma-separate them)';
    }
    if (!isSingleEmailAddress(trimmed.toLowerCase())) {
      return `"${trimmed}" is not a valid email address`;
    }
  }
  return true;
}
